import { IVehicleInsurable } from '@webapp/risks';
import { IBasePolicy, PolicyTabNames } from '../../interfaces/policies.interface';
import { InsurableMapper } from '../insurableMapper';

export class QuadInsurableMapper implements InsurableMapper<IVehicleInsurable> {
  map(insurable: unknown): IVehicleInsurable {
    return insurable as IVehicleInsurable;
  }

  getTitle(policy: IBasePolicy, insurable: IVehicleInsurable): string {
    return `#${policy.internalNumber} - ${insurable?.description || policy.title || ''}`;
  }

  getTabs(): string[] {
    return [PolicyTabNames.INFO, PolicyTabNames.INSURED, PolicyTabNames.ACTIVATIONS, PolicyTabNames.ENDORSEMENT];
  }
}
